export const CLIENT_TAB_TYPE = {
  1: 'all',
  2: 'official',
  3: 'driver',
};
